<template>
  <div>
    <MasterGroupClassHistory
      :selectedMasterGroupClassId="$route.params.id"
    ></MasterGroupClassHistory>
    <MasterGroupClassStudentDetails
      :selectedMasterGroupClassId="$route.params.id"
    ></MasterGroupClassStudentDetails>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
  components: {
    MasterGroupClassHistory,
    MasterGroupClassStudentDetails,
  },
};
import MasterGroupClassHistory from "@/views/components/GroupClass/MasterGroupClass/MasterGroupClassHistory.vue";
import MasterGroupClassStudentDetails from "@/views/components/GroupClass/MasterGroupClass/MasterGroupClassStudentDetails.vue";
</script>
